import { create } from "zustand";

interface SelectedEntityData {
  entityType: "section" | "page";
  entityId: string;
  pageIds: string[];
}

interface SelectedEntityState {
  selectedEntity: SelectedEntityData | null;

  // Set selected section with entityType, entityId and pageIds
  setSelectedEntity: (
    entityType: "section" | "page",
    entityId: string,
    pageIds: string[]
  ) => void;

  // Get current selected entity
  getSelectedEntity: () => SelectedEntityData | null;

  // Get current selected section entityId
  getSelectedEntityId: () => string | null;

  // Get current selected section pageIds
  getSelectedEntityPageIds: () => string[];

  // Clear selected section
  clearSelectedEntity: () => void;
}

export const useSelectedEntityStore = create<SelectedEntityState>(
  (set, get) => ({
    selectedEntity: null,

    setSelectedEntity: (
      entityType: "section" | "page",
      entityId: string,
      pageIds: string[] | null
    ) => {
      set({
        selectedEntity: {
          entityType,
          entityId,
          pageIds: pageIds || [],
        },
      });
    },

    getSelectedEntity: () => {
      return get().selectedEntity;
    },

    getSelectedEntityId: () => {
      return get().selectedEntity?.entityId || null;
    },

    getSelectedEntityPageIds: () => {
      return get().selectedEntity?.pageIds || [];
    },

    clearSelectedEntity: () => {
      set({ selectedEntity: null });
    },
  })
);
